<template>
  <div class="o-modal" style="z-index:99;">
    <div class="o-modal-content">
      <div class="o-modal-header">
        <a
            @click="closeModal()"
            class="close clickable"
          ><i class="far fa-times"></i></a>
          <p class="lead">Bulk Update {{ selectedBlocks.length }} Blocks</p>
      </div><!-- /.o-modal-header -->
      <div class="o-modal-body">
        <div>
          <label for="property">Header to update:</label>
          <b-form-select v-model="selectedPropertyName" :options="properties" :text-field="'label'" :value-field="'machine_name'" first-option-text="Please select one"></b-form-select>
        </div>
        <div v-if="selectedProperty" class="mt-2">
          <label for="newValue">New value:</label>
          <div v-if="selectedProperty.type === 'Date and Time'">
            <b-form-datepicker v-model="newValue" id="newValue"></b-form-datepicker>
            <div v-if="selectedProperty.includeTime">
              <label for="newTime">New time:</label>
              <b-form-timepicker v-model="newTime" id="newTime" minute-step="5"></b-form-timepicker>
              <!-- <b-button @click="setNow" variant="secondary" class="mt-2">Set to Now</b-button> -->
            </div>
          </div>
          <b-form-input v-else-if="selectedProperty.type === 'Number'" v-model.number="newValue" id="newValue" type="number"></b-form-input>
          <b-form-select v-else-if="selectedProperty.type === 'Select'" v-model="newValue" :options="selectedProperty.opts"></b-form-select>
          <b-form-input v-else v-model="newValue" id="newValue"></b-form-input>
        </div>
        <div class="mt-2">
          <b-button
            @click="confirmUpdate = true"
            variant="primary"
            v-if="selectedPropertyName && newValue"
          >Apply</b-button>
        </div>
      </div><!-- /.o-modal-body -->
    </div><!-- /.o-modal-content -->
    <Confirm
      v-if="confirmUpdate"
      text="Are you sure you want to bulk update all of these blocks? This will override any existing data in the selected header. Revisions will be created for each block."
      v-on:confirmed="bulkUpdate($event)"
    />
  </div><!-- /.o-modal -->
</template>

<script>
import Confirm from '../Confirm'

export default {
  props: ['selectedBlocks'],
  data () {
    return {
      selectedPropertyName: '',
      newValue: '',
      newTime: '',
      properties: [],
      confirmUpdate: false
    }
  },
  components: {
    Confirm
  },
  created () {
    this.properties.push({
      label: 'Description',
      machine_name: 'description',
      type: 'Text'
    })
    if (this.$store.state.farm.blockFields) {
      this.$store.state.farm.blockFields.forEach(field => {
        if (field.type !== 'Image' && field.type !== 'Computer Vision') {
          this.properties.push({
            label: field.label,
            machine_name: field.machine_name,
            type: field.type,
            includeTime: field.includeTime || false,
            opts: field.options || false
          })
        }
      })
    }
  },
  computed: {
    selectedProperty () {
      return this.properties.find(prop => prop.machine_name === this.selectedPropertyName)
    }
  },
  methods: {
    closeModal () {
      this.$emit('closeModal')
    },
    bulkUpdate (confirmed) {
      if (!confirmed) {
        this.confirmUpdate = false
      } else {
        // You might need to combine newValue and newTime if includeTime is true
        let newValue = this.newValue
        if (this.selectedProperty.includeTime) {
          newValue = `${this.newValue} ${this.newTime}`
        }
        // Emit an event with the selected property and new value
        this.$emit('bulkUpdate', this.selectedProperty, newValue)
        this.closeModal()
      }
    }
    // setNow () {
    //   const now = new Date()
    //   this.newValue = now

    //   const hours = now.getHours().toString().padStart(2, '0')
    //   let minutes = Math.floor(now.getMinutes() / 5) * 5 // Rounding down to the nearest 5
    //   minutes = minutes.toString().padStart(2, '0')

    //   this.newTime = `${hours}:${minutes}`
    // }
  }
}
</script>
